import styled from 'styled-components';

export const Farm = styled.div`
  background: white;
  min-height: 100%;
`
